import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateTask, privateTasksManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { PRIVATE_TASK_MODULE } from './module';

const dataObjectModule = getDataObjectsModule<IPrivateTask>(privateTasksManager, 3);
const searchModule = getSearchModule<IPrivateTask>(privateTasksManager);

const privateTasksModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_TASK_MODULE, privateTasksModuleInstance);

export { PRIVATE_TASK_MODULE };
